import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {LoginComponent} from '../../logins/login/login.component';
import {EsaloginComponent} from '../../logins/esalogin/esalogin.component';
import {HstloginComponent} from '../../logins/hstlogin/hstlogin.component';
import {AgvsloginComponent} from '../../logins/agvslogin/agvslogin.component';
import {HomeComponent} from '../../main/home/home.component';
import {TransportComponent} from '../../modules/transport/transport.component';
import {TransportTaskComponent} from '../../modules/transport/transport-task/transport-task.component';
import {DamagereportComponent} from '../../modules/transport/damagereport/damagereport.component';
import {WheelnewsComponent} from '../../modules/wheelnews/wheelnews.component';
import {WheelnewsTaskComponent} from '../../modules/wheelnews/wheelnews-task/wheelnews-task.component';
import {WheelnewsOrderviewComponent} from '../../modules/wheelnews/wheelnews-orderview/wheelnews-orderview.component';
import {AirportparkingComponent} from '../../modules/airportparking/airportparking.component';
import {StateComponent} from '../../modules/state/state.component';
import {AdministrationComponent} from '../../modules/administration/administration.component';
import {NewsComponent} from '../../main/news/news.component';
import {UsermanagementComponent} from '../../modules/administration/usermanagement/usermanagement.component';
import {MailServiceComponent} from '../../modules/administration/mail-service/mail-service.component';
import {DamageAdministrationComponent} from '../../modules/damage-administration/damage-administration.component';
import {DamageAdministrationCoreDataComponent} from '../../modules/damage-administration/damage-administration-core-data/damage-administration-core-data.component';
import {DamageAdministrationRecordComponent} from '../../modules/damage-administration/damage-administration-record/damage-administration-record.component';
import {DamageAdministrationOverviewComponent} from '../../modules/damage-administration/damage-administration-overview/damage-administration-overview.component';
import {DamagereportsComponent} from '../../modules/damage-administration/damagereports/damagereports.component';
import {DamageAdministrationEvaluationComponent} from '../../modules/damage-administration/damage-administration-evaluation/damage-administration-evaluation.component';
import {DamageAdministrationLogsComponent} from '../../modules/damage-administration/damage-administration-logs/damage-administration-logs.component';
import {ChangePasswordComponent} from '../../main/change-password/change-password.component';
import {ApiTokenComponent} from '../../modules/administration/api-token/api-token.component';
import {TrackingComponent} from '../../main/tracking/tracking.component';
import {LogisticsComponent} from '../../modules/logistics/logistics.component';
import {LogisticsTaskComponent} from '../../modules/logistics/logistics-task/logistics-task.component';
import {HomedeliveryTaskComponent} from '../../modules/transport/homdelivery-task/homedelivery-task.component';
import {DamageCase} from 'src/app/modules/transport/damage-case/damage-case.component';
import {DamageCaseRecord} from 'src/app/modules/transport/damage-case/damage-case-record/damage-case-record.component';
import {DamageCaseOpen} from 'src/app/modules/transport/damage-case/damage-case-open/damage-case-open.component';
import {DamageCaseClosed} from 'src/app/modules/transport/damage-case/damage-case-closed/damage-case-closed.component';
import {DamageAdministrationCase} from 'src/app/modules/damage-administration/damage-administration-case/damage-administration-case.component';
import {DamageAdministrationCaseOverview} from 'src/app/modules/damage-administration/damage-administration-case-overview/damage-administration-case-overview.component';

const routes: Routes = [
  { path: '', component: LoginComponent },
  { path: 'login', component: LoginComponent },
  { path: 'esalogin', component: EsaloginComponent },
  { path: 'hstlogin', component: HstloginComponent },
  { path: 'agvslogin', component: AgvsloginComponent },
  { path: 'home', component: HomeComponent },
  { path: 'transport', component: TransportComponent },
  { path: 'transport-task', component: TransportTaskComponent },
  { path: 'damagereport', component: DamagereportComponent },
  { path: 'wheelnews', component: WheelnewsComponent },
  { path: 'wheelnews-task', component: WheelnewsTaskComponent },
  { path: 'wheelnews-orderview', component: WheelnewsOrderviewComponent },
  { path: 'airportparking', component: AirportparkingComponent },
  { path: 'status', component: StateComponent },
  { path: 'administration', component: AdministrationComponent },
  { path: 'news', component: NewsComponent },
  { path: 'usermanagement', component: UsermanagementComponent },
  { path: 'mailService', component: MailServiceComponent },
  { path: 'damageAdministration', component: DamageAdministrationComponent },
  { path: 'damageAdministrationCoreData', component: DamageAdministrationCoreDataComponent },
  { path: 'damageAdministrationRecord', component: DamageAdministrationRecordComponent },
  { path: 'damageAdministrationRecord/:reportId', component: DamageAdministrationRecordComponent },
  { path: 'damageAdministrationOverview', component: DamageAdministrationOverviewComponent },
  { path: 'damageAdministrationReport', component: DamagereportsComponent },
  { path: 'damageAdministrationEvaluation', component: DamageAdministrationEvaluationComponent },
  { path: 'damageAdministrationLogs', component: DamageAdministrationLogsComponent },
  { path: 'changePassword', component: ChangePasswordComponent },
  { path: 'apiToken', component: ApiTokenComponent },
  { path: 'tracking', component: TrackingComponent},
  { path: 'logistics', component: LogisticsComponent},
  { path: 'logistics-task', component: LogisticsTaskComponent },
  { path: 'homedelivery', component: HomedeliveryTaskComponent },
  { path: 'damage-case', component: DamageCase },
  { path: 'damage-case-record', component: DamageCaseRecord },
  { path: 'damage-case-open', component: DamageCaseOpen },
  { path: 'damage-case-closed', component: DamageCaseClosed },
  { path: 'damageAdministrationCase', component: DamageAdministrationCase },
  { path: 'damageAdministrationCase/:id', component: DamageAdministrationCase },
  { path: 'damageAdministrationCaseOverview', component: DamageAdministrationCaseOverview },
  { path: '**', redirectTo: '/login'} // last position
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
